import { render, staticRenderFns } from "./LokasiView.vue?vue&type=template&id=ac49c226"
import script from "./LokasiView.vue?vue&type=script&lang=js"
export * from "./LokasiView.vue?vue&type=script&lang=js"
import style0 from "./LokasiView.vue?vue&type=style&index=0&id=ac49c226&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports